import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import * as GroupPermissionsActions from '../actions/group-permissions.actions';
import { PermissionsService } from '@fc-core/services/permissions.service';
import { NotificationService } from '@fc-core';

@Injectable()
export class GroupPermissionsEffects {
  loadGroupPermissions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupPermissionsActions.loadGroupPermissions),
      concatMap(({ groupId }) =>
        this.permissionsService.getGroupPermissions(groupId).pipe(
          map((data) =>
            GroupPermissionsActions.loadGroupPermissionsSuccess({ data }),
          ),
          catchError((error) =>
            of(GroupPermissionsActions.loadGroupPermissionsFailure({ error })),
          ),
        ),
      ),
    );
  });

  addGroupPermission$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupPermissionsActions.addGroupPermission),
      concatMap(({ groupId, permissionId }) =>
        this.permissionsService.addGroupPermissions(groupId, permissionId).pipe(
          map(() => {
            this.notifications.showSuccess('Permission successfully added');
            return GroupPermissionsActions.addGroupPermissionSuccess({
              permissionId,
              groupId,
            });
          }),
          catchError((error) =>
            of(GroupPermissionsActions.loadGroupPermissionsFailure({ error })),
          ),
        ),
      ),
    );
  });

  removeGroupPermission$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GroupPermissionsActions.removeGroupPermission),
      concatMap(({ groupId, permissionId }) =>
        this.permissionsService
          .removeGroupPermissions(groupId, permissionId)
          .pipe(
            map(() => {
              this.notifications.showSuccess('Permission successfully removed');
              return GroupPermissionsActions.removeGroupPermissionSuccess({
                permissionId,
                groupId,
              });
            }),
            catchError((error) =>
              of(
                GroupPermissionsActions.loadGroupPermissionsFailure({ error }),
              ),
            ),
          ),
      ),
    );
  });

  constructor(
    private actions$: Actions,
    private permissionsService: PermissionsService,
    private notifications: NotificationService,
  ) {}
}
